import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { OpportunitiesTable } from './style';

function Opportunities({ className, opportunities, onInit }) {
  useEffect(() => {
    onInit();
  }, [onInit]);

  return <OpportunitiesTable className={className} opportunities={opportunities} />;
}

Opportunities.propTypes = {
  className: PropTypes.string,
  opportunities: PropTypes.array.isRequired,
  onInit: PropTypes.func.isRequired
};

export default Opportunities;
